import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 2fr 2fr 2fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    backgroundColor: theme.palette.background.paper,
    marginTop: 36,
    borderRadius: 12
  },
  tableSortLabel: {
    color: theme.palette.grey[800]
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 42,
    paddingTop: 6,
    paddingBottom: 6
  }
}))

export default useStyles
